"use client"; // May not be needed, but safe

import React from 'react';
import Image from 'next/image';
import Marquee from 'react-fast-marquee';

const SyncAppsSection = () => {
  // Using local images from /public/images/meeting_platforms/ with correct extensions
  const platforms = [
    { name: 'Microsoft Teams', image: '/images/meeting_platforms/teams.webp' },
    { name: 'Webex', image: '/images/meeting_platforms/webex.png' },
    { name: 'Zoom', image: '/images/meeting_platforms/zoom.png' },
    // No Google Meet file found in the directory
  ];

  return (
    <section className="relative bg-[#121212] text-white py-12 md:py-20 overflow-hidden rounded-xl border border-white/20 shadow-[0_0_8px_rgba(255,255,255,0.15)] w-[80%] md:w-[83%] mx-auto">
      {/* Background image - Reverted to cover */}
      <Image
        fill // Use fill again
        src="/images/home/hero-dashboard.png" // Changed to hero-dashboard.png
        alt="Dashboard background"
        // Removed width/height
        className="absolute inset-0 w-full h-full object-cover z-0" // Use object-cover
        unoptimized={true}
      />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 gap-12 items-center">
          {/* Content Column - Center text, remove order classes */}
          <div className="space-y-8 text-center"> {/* Removed lg:text-left, order-1, lg:order-2 */}
            <h2 className="text-3xl md:text-5xl font-bold text-gray-100 mb-4">
              Sync With Your Favorite Meeting Apps
            </h2>
            <p className="text-lg text-gray-300">
              MeetMinutes works with all major meeting platforms, to make note-taking automated & hassle-free.
            </p>
          </div>

          {/* Animation Column - Constrain width and center */}
          <div className="w-full max-w-lg mx-auto overflow-hidden relative"> {/* Added max-w-lg mx-auto */}
            <Marquee gradient={false} speed={30} pauseOnHover className="flex whitespace-nowrap">
              {platforms.map((platform, index) => (
                <div
                  key={`${platform.name}-${index}`} 
                  className="flex-shrink-0 w-[180px] mx-3 flex items-center justify-center h-28"
                >
                  <Image
                    src={platform.image}
                    alt={platform.name}
                    width={100}
                    height={60}
                    className="object-contain opacity-80 hover:opacity-100 transition-opacity"
                  />
                </div>
              ))}
            </Marquee>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SyncAppsSection; 